<template>
    <div class="businessList">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>商业专题</el-breadcrumb-item>
            <el-breadcrumb-item>查询专题</el-breadcrumb-item>
        </el-breadcrumb>
        <el-table class="business-list-table" :data="specialList" stripe border>
            <el-table-column label="专题ID" align='center' width="100px">
                <template scope="scope">
                    <span>{{scope.row.specialId}}</span>
                </template>
            </el-table-column>
            <el-table-column label="标题" align='center'>
                <template scope="scope">
                    <span>{{scope.row.specialName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="链接" align='center'>
                <template scope="scope">
                    <a target="_blank" :href="baseUrl + scope.row.specialId">{{baseUrl + scope.row.specialId}}</a>
                </template>
            </el-table-column>
            <el-table-column label="项目经理" align='center'  width="120px">
                <template scope="scope">
                    <span>{{scope.row.userName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align='center'>
                <template scope="scope">
                    <!--<el-button size="small" type="info" @click="">编辑</el-button>-->
                    <el-button v-if="scope.row.isShowDes === 0" size="small" type="success" @click="openDesc(scope.row.specialId)">开启描述</el-button>
                    <el-button v-if="scope.row.isShowDes === 1" size="small" type="danger" @click="closeDesc(scope.row.specialId)">关闭描述</el-button>
                    <el-button size="small" type="danger" @click="deleteSpecial(scope.row.specialId)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页器-->
        <el-pagination class="page-control" layout="prev, pager, next" :total="specialListLength" @current-change="changePage"></el-pagination>
        <!--end-->
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: "businessList",
    data() {
        return {
            specialList: null,
            specialListLength: 0,
            currentPage: 1,
            baseUrl: CONFIG.HOST + '/view/special/'
        };
    },
    mounted(){
        this._init();
    },
    computed: {
        ...mapGetters({
            userInfo: 'getUserInfo'
        })
    },
    methods: {
        _getSpecialListCount() {
            this.$http.get(CONFIG.HOST + "/special/listPaging/1" + "?t=" + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.specialListLength = result.data.totalCounts[0].counts || 0;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _getSpecialPageList(pageId = 1){
            this.$http.get(CONFIG.HOST + '/special/listPaging/' + pageId + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.specialList = result.data.listPaging;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);          
        },
        deleteSpecial(specialId) {
            this._confirmMessage('是否确定删除specialId=' + specialId + '的专题？', ()=>{
                if (specialId < 0) {
                    this.$notify.error({
                        message: '【营销平台】specialId=' + specialId + '的专题不存在'
                    });
                    return;
                }
                this.$http.delete(CONFIG.HOST + '/special/deleteItem/' + specialId).then((response)=>{
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: '【营销平台】成功删除specialId=' + specialId + '的专题'
                        });
                        this._getSpecialPageList(this.currentPage);
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                },(response)=>{
                    console.log(response);
                });
            });
        },
        openDesc(specialId = -1){
            this.$http.put(CONFIG.HOST + '/special/switchDescribe/' + specialId, { type: 1 }).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】成功开启专题描述'
                    });
                    this._getSpecialPageList(this.currentPage);
                } else {
                    this.$notify.success({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        closeDesc(specialId = -1){
            this.$http.put(CONFIG.HOST + '/special/switchDescribe/' + specialId, { type: 0 }).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】成功关闭专题描述'
                    });
                    this._getSpecialPageList(this.currentPage);
                } else {
                    this.$notify.success({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        changePage(page){
            this.currentPage = page;
            this._getSpecialPageList(page);
        },
        _init() {
            this._getSpecialListCount();
            this._getSpecialPageList();
        }
    }
};
</script>
<style lang="less">
    .businessList{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .business-list-table{
            min-width: 980px;
        }
        .page-control{
            margin: 20px auto 0 auto;
        }
    }  
</style>


// WEBPACK FOOTER //
// List.vue?9557fa7a